<button
  #button
  [class]="buttonClasses"
  (click)="clickAction($event)"
  [title]="title"
  [disabled]="disabled"
  (blur)="onBlur($event)"
  (focus)="onFocus($event)"
  [attr.tabIndex]="!enableTabbing ? '-1' : null"
>
  <i [class]="iconClass"></i>
</button>
